<template>
  <div class="step__block-row">
    <p class="step__block-text">
      Include COMBINED delivery price in partition price
    </p>
    <CheckboxField
      v-model="deliveryStore.isIncludeCombinedDeliveryInPrice"
      :disabled="disableCheckbox"
      @update:modelValue="onIncludeCombinedInPriceUpdate"
    />
  </div>
</template>

<script setup lang="ts">
import { watch, ref } from "vue";

import { CheckboxField } from "@/shared";

import { useDeliveryStore } from "@/stores/new/delivery.store";
import { useNewEstimateStore } from "@/stores/new/estimateStore";
import { DeliveryCombinedType } from "@/app/constants";

const deliveryStore = useDeliveryStore();
const estimateStore = useNewEstimateStore();
const disableCheckbox = ref(false);

const onIncludeCombinedInPriceUpdate = (value: boolean | undefined) => {
  if (value === false) {
    deliveryStore.isChangedCombinedCheckbox = true;
  }
};

watch(
  () => [
    deliveryStore.isIncludeCombinedDeliveryInPrice,
    estimateStore.estimate.delivery,
  ],
  ([isIncludeCombinedDeliveryInPrice, isDelivery]) => {
    if (isDelivery) {
      estimateStore.estimate.isIncludeCombinedDeliveryInPrice =
        isIncludeCombinedDeliveryInPrice;
    } else {
      estimateStore.estimate.isIncludeCombinedDeliveryInPrice = false;
    }
  },
  {
    deep: true,
  },
);
watch(
  () => deliveryStore.deliveryType,
  (value) => {
    disableCheckbox.value = value !== DeliveryCombinedType;

    if (value === DeliveryCombinedType) {
      if (deliveryStore.isChangedCombinedCheckbox) {
        return;
      }
      deliveryStore.isIncludeCombinedDeliveryInPrice = true;
      return;
    }

    deliveryStore.isIncludeCombinedDeliveryInPrice = false;
  },
  {
    deep: true,
    immediate: true,
  },
);
</script>

<style scoped>
.step__block-text {
  font-family: Gilroy;
  font-weight: 400;
  font-size: 13px;
  line-height: 100%;
  color: rgba(5, 33, 65, 1);
}

.step__block-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
</style>
